module.exports = __webpack_public_path__ + "img/amazing-caves-coverimage.cde5db45.jpg";